module.exports = __webpack_public_path__ + "img/fail.227aea9c.png";